import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BsCloudUpload } from 'react-icons/bs';
import { metadataService } from '../../_services'

class Dropzone extends Component {
    constructor(props) {
        super(props)
        this.state = { hightlight: false }
        this.fileInputRef = React.createRef()

        this.openFileDialog = this.openFileDialog.bind(this)
        this.onFilesAdded = this.onFilesAdded.bind(this)
        this.onDragOver = this.onDragOver.bind(this)
        this.onDragLeave = this.onDragLeave.bind(this)
        this.onDrop = this.onDrop.bind(this)
    }

    openFileDialog() {
        if (this.props.disabled) return
        this.fileInputRef.current.click()
    }

    onFilesAdded(evt, name) {
        if (this.props.disabled) return
        const files = evt.target.files
        if (this.props.onFilesAdded) {
            const array = this.fileListToArray(files)
            this.props.onFilesAdded(array, name)
        }
    }

    onDragOver(evt) {
        evt.preventDefault()

        if (this.props.disabled) return

        this.setState({ hightlight: true })
    }

    onDragLeave() {
        this.setState({ hightlight: false })
    }

    onDrop(event) {
        event.preventDefault()

        if (this.props.disabled) return

        const files = event.dataTransfer.files
        if (this.props.onFilesAdded) {
            const array = this.fileListToArray(files)
            this.props.onFilesAdded(array)
        }
        this.setState({ hightlight: false })
    }

    fileListToArray(list) {
        const array = []
        for (var i = 0; i < list.length; i++) {
            array.push(list.item(i))
        }
        return array
    }

    render() {
        return (
            <div
                className={`Dropzone ${this.state.hightlight ? 'DropzoneHighlight' : ''}`}
                onDragOver={this.onDragOver}
                onDragLeave={this.onDragLeave}
                onDrop={this.onDrop}
                onClick={this.openFileDialog}
                style={{ cursor: this.props.disabled ? 'default' : 'pointer' }}
            >
                <input
                    name={this.props.name}
                    ref={this.fileInputRef}
                    className="DropzoneFileInput"
                    type="file"
                    multiple
                    onChange={(event) => this.onFilesAdded(event, this.props.name)}
                />
                <BsCloudUpload
                    alt="upload"
                    className="DropzoneIcon"
                />
                <span>{metadataService.getMessage("UploadFiles")}</span>
            </div>
        )
    }
}

Dropzone.propTypes = {
    onFilesAdded: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string
}

export default Dropzone


// WEBPACK FOOTER //
// ./src/components/subcomponents/Dropzone.jsx